import { useLibraryPost } from '@/features/inquiry-library';
import type { AskAvailableResult } from '@/services/ask/api';

/**
 * Fetches the full body of a Research result's lead post. Shared by every
 * presentation of a result — the fallback sheet, the desktop pane and the
 * pushed result screen.
 *
 * Only the lead post is read. A result can still name several posts on one
 * question, but that is a backend defect being fixed there, so the reader is
 * never offered the others.
 */
export function useLeadPost(result: AskAvailableResult | undefined) {
  const post = result?.posts[0];

  const { data, isPending, isError, refetch } = useLibraryPost(
    { postId: post?.id ?? 0 },
    { enabled: post != null }
  );

  return { post, data, isPending, isError, refetch };
}
